import React from 'react';
import { TextField, useRecordContext } from 'react-admin';
import { Tooltip, Typography } from '@mui/material';
import { hotlineBlocklistFields } from '../../hotlineBlocklist.model';

const NotesField = ({ source = hotlineBlocklistFields.notes, label = 'Notes', maxLength = 50, ...props }) => {
    const record = useRecordContext();
    if (!record || !record[source]) return <Typography variant="body2" color="text.secondary">—</Typography>;

    const notes = record[source];
    const truncatedNotes = notes.length > maxLength ? `${notes.substring(0, maxLength)}...` : notes;

    if (notes.length <= maxLength) {
        return <TextField source={source} label={label} {...props} />;
    }

    return (
        <Tooltip title={notes} placement="top">
            <Typography variant="body2" sx={{ cursor: 'help' }}>
                {truncatedNotes}
            </Typography>
        </Tooltip>
    );
};

export default NotesField; 